import { LotOccupationInteractor, LotOccupationRequest, LotOccupationStructRequest} from "../../Coordinator/LotOccupation/LotOccupationInteractor";

export class LotOccupationViewModel {
    private interactor: LotOccupationInteractor;

	constructor() {
		this.interactor = new LotOccupationInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new LotOccupationRequest(
            obj["sgepocupacaolote"] ? parseInt(obj["sgepocupacaolote"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new LotOccupationStructRequest(
            obj["sgepocupacaolote"] ? parseInt(obj["sgepocupacaolote"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}